import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4 bg-cream-50" data-id="element-99" data-mp="1o3x39onecu32">
      <div className="max-w-2xl mx-auto text-center" data-id="element-100" data-mp="1o33s8bhenif4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-sage-100 border border-sage-300 flex items-center justify-center" data-id="element-101" data-mp="223y6har4wdlp">
          <ShieldCheck className="w-9 h-9 text-sage-600" data-id="element-102" data-mp="1x5muatdd9r0b" />
        </div>
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-wine tracking-tight" data-id="element-103" data-mp="19e7pmty4axlw">
          GARANTÍA DE 7 DÍAS
        </h2>
        <span className="inline-block mt-2 mb-5 bg-sage-500 text-white text-[11px] font-bold uppercase tracking-widest px-3 py-1 rounded-full" data-id="element-104" data-mp="14h8vwcid8so8">
          ✓ Compra sin riesgo
        </span>

        <div className="rounded-2xl bg-wine px-5 py-7 sm:px-8" data-id="element-105" data-mp="1ed263p8m4a2u">
          <p className="text-base sm:text-lg text-white font-semibold leading-snug" data-id="element-106" data-mp="qnzo2ga2gf7t">
            Accedé al Kit. Exploralo. Empezá a recorrer las guías y utilizar las
            herramientas.
          </p>
          <p className="text-sm sm:text-base text-white/70 mt-3 leading-snug" data-id="element-107" data-mp="p01hw9gad5as">
            Si durante los próximos 7 días sentís que no era lo que esperabas:
          </p>
          <p className="font-serif text-6xl sm:text-7xl font-bold text-rose-300 leading-none mt-4" data-id="element-108" data-mp="tw9ubf33mke9">
            100%
          </p>
          <p className="text-lg sm:text-xl font-bold text-white uppercase tracking-tight mt-2" data-id="element-109" data-mp="12r69co9i2ra1">
            De tu dinero de vuelta
          </p>
          <p className="text-sm text-white/60 mt-2" data-id="element-110" data-mp="62i3srez0whi">Simple y sin complicaciones.</p>
        </div>

        <p className="text-sm text-ink-soft mt-3" data-id="element-111" data-mp="b00fuqoabrtq">
          Tenés 7 días para decidir si el Kit es para vos.
        </p>
      </div>
    </section>;
}